module.exports = __webpack_public_path__ + "img/logo boutique.1dfa87b5.png";